module.exports = {
      id: "tick-usage",
      viewBox: "0 0 23.788 23.787",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#tick",
      toString: function () {
        return this.url;
      }
    }